import React from 'react';
import Container from './Container';
import Section from './Section';

const LoggedOut: React.FC<any> = props => {
    return (
        <Section>
            <Container>
                <h2>You have logged out successfully.</h2>
            </Container>
        </Section>
    );
};

export default LoggedOut;



// WEBPACK FOOTER //
// ./src/components/LoggedOut.tsx